import {
  cellDisabledStyle,
  cellPaddingStyle,
  cssClass,
  elideTextStyle,
  TypedBodyCellProps
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import { Formatters } from '../../../../gen-src/Localize';

const numberCellClass = cssClass('numberCell', elideTextStyle, cellPaddingStyle, {
  textAlign: 'right',
});
const disabledNumberCellClass = cssClass('numberCell', elideTextStyle, cellPaddingStyle, cellDisabledStyle, {
  textAlign: 'right',
});

interface NumberCellFormatterProps {
  readonly disabled?: boolean;
  readonly number: number | null;
}

function NumberCellFormatter(props: NumberCellFormatterProps) {
  const formattedNumber = props.number != null ? Formatters.formatCount(props.number) : undefined;
  return (
    <div className={props.disabled ? disabledNumberCellClass : numberCellClass} title={formattedNumber}>
      {formattedNumber}
    </div>
  );
}

export function createNumberCellFormatter<T>(
  getNumberFromRowData: (rowData: T) => number | null,
  getDisabledFromRowData?: (rowData: T) => boolean
): React.Factory<TypedBodyCellProps<T>> {
  return (props: TypedBodyCellProps<T>) => (
    <NumberCellFormatter
      disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
      number={getNumberFromRowData(props.row.data)}
    />
  );
}
